/**
 * @generated SignedSource<<b2653a2cc881da5eba0aef7c87146813>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditorPreferencesQueryFragment$data = {
  readonly confluenceEditorSettings: {
    readonly toolbarDockingInitialPosition: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "EditorPreferencesQueryFragment";
};
export type EditorPreferencesQueryFragment$key = {
  readonly " $data"?: EditorPreferencesQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorPreferencesQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EditorPreferencesQueryFragment",
  "selections": [
    {
      "concreteType": "ConfluenceEditorSettings",
      "kind": "LinkedField",
      "name": "confluenceEditorSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "toolbarDockingInitialPosition"
        }
      ]
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "c14a58c792cd6196c5f117a58ba70054";

export default node;
